import { render, staticRenderFns } from "./RtcGroupJoin.vue?vue&type=template&id=f60bf2bc&scoped=true"
import script from "./RtcGroupJoin.vue?vue&type=script&lang=js"
export * from "./RtcGroupJoin.vue?vue&type=script&lang=js"
import style0 from "./RtcGroupJoin.vue?vue&type=style&index=0&id=f60bf2bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../box-im/im-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f60bf2bc",
  null
  
)

export default component.exports